module.exports = __webpack_public_path__ + "static/media/Kevin-and-Tolu-485-121.9017579a.jpg";